/* NC EKSTRA GARANTI – holder garanti-linjer i takt med varen i kurven (pilot 2026-10-21).
   Garanti-linjen har egenskaben _nc_warranty_for = varens variant-id (sat af snippets/nc-warranty-offer.liquid).
   Ændres antallet af varen, eller fjernes den, får garantien samme antal (0 = fjernes). */
(function () {
  var busy = false;
  function sync(cart) {
    if (busy || !cart || !cart.items) return;
    var qtyByVariant = {};
    cart.items.forEach(function (i) {
      if (!(i.properties && i.properties._nc_warranty_for)) qtyByVariant[i.variant_id] = (qtyByVariant[i.variant_id] || 0) + i.quantity;
    });
    var updates = {}, n = 0;
    cart.items.forEach(function (i) {
      var forId = i.properties && i.properties._nc_warranty_for;
      if (!forId) return;
      var want = qtyByVariant[forId] || 0;
      if (i.quantity !== want) { updates[i.key] = want; n++; }
    });
    if (!n) return;
    busy = true;
    fetch((window.routes && window.routes.cart_update_url || '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      if (/\/cart\/?$/.test(location.pathname)) return location.reload();
      var mc = document.querySelector('mini-cart');
      if (mc && mc.updateSectionContents) mc.updateSectionContents();
    }).finally(function () { busy = false; });
  }
  // Garanti-afkrydsning under varen i kurven (snippets/nc-warranty-cart-offer.liquid): ☑ tilføjer, ☐ fjerner.
  document.addEventListener('change', function (e) {
    var c = e.target.closest('[data-nc-wtoggle]');
    if (!c) return;
    c.disabled = true;
    var req;
    if (c.checked) {
      var props = { _nc_warranty_for: c.dataset.forId };
      props[c.dataset.forLabel] = c.dataset.forTitle;
      req = fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(c.dataset.warrantyId), quantity: Number(c.dataset.qty) || 1, properties: props }] })
      });
    } else {
      req = fetch((window.routes && window.routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: c.dataset.key, quantity: 0 })
      });
    }
    req.then(function () {
      if (/\/cart\/?$/.test(location.pathname)) return location.reload();
      var mc = document.querySelector('mini-cart');
      if (mc && mc.updateSectionContents) mc.updateSectionContents();
    }).finally(function () { c.disabled = false; });
  });
  // Lige lagt i kurven uden garanti: fremhæv tilbuddet under varen i kurv-skuffen.
  document.addEventListener('cart:item-add', function (e) {
    var items = (e.detail && e.detail.items) || [];
    setTimeout(function () {
      items.forEach(function (i) {
        var el = document.querySelector('[data-nc-wcart-for="' + i.variant_id + '"]');
        if (el && el.classList.contains('nc-wline--offer')) el.classList.add('is-fresh');
      });
    }, 300);
  });
  ['cart:item-remove', 'cart:item-quantity-update'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.detail && e.detail.cart && e.detail.cart.items) sync(e.detail.cart);
      else fetch('/cart.js').then(function (r) { return r.json(); }).then(sync);
    });
  });
})();
